import { Component, DoCheck, Inject, OnInit } from '@angular/core';
import { UserStorageService } from '../../../services/local/user-storage.service';
import { Router } from '@angular/router';
import { NavTabModel } from 'src/app/core/nav-storage/model/nav-tab.dto';
import { NavStorageService } from 'src/app/core/nav-storage/services/nav-storage.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DOCUMENT } from '@angular/common';
import { LanguageDto } from 'src/app/core/models/catalog/language.dto';
import { CatLanguageService } from 'src/app/core/services/global-catalog/catalog-language.service';
import { WorkplaceStorageService } from 'src/app/core/services/local/workplaces-storage.service';
import { SendInfoComponentService } from 'src/app/core/services/local/send-info.component.service';
import { ProfileUserDialog } from 'src/app/inside/configuration/user/components/profile-user/profile-user-dialog';
import { MatDialog } from '@angular/material/dialog';
import { TranslateHelper } from '../../helpers/translate.helper';
import { TranslateDto } from 'src/app/core/models/translate/translate.dto';
import { LockSessionService } from 'src/app/core/services/auth/lock-session.service';
import { StringUtilsHelper } from '../../helpers/strings.helper';



@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss']
})
export class TopNavbarComponent implements OnInit, DoCheck {
  elem: any;
  activeTab: boolean = true;
  hiddenBadge: boolean = false;
  viewPanel: boolean = true;
  fullname: string = "";
  languages: LanguageDto[] = [];
  languageCve = "";
  tablist: NavTabModel[] = [];
  changeTranslate: string = "";
  listTraduction: TranslateDto = {} as TranslateDto;

  constructor(
    private userStorageService: UserStorageService,
    private tabsStorageService: NavStorageService,
    private router: Router,
    public breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) private document: any,
    private languageCatService: CatLanguageService,
    private workplaceStorageService: WorkplaceStorageService,
    private translateHelper: TranslateHelper,
    public dialog: MatDialog,
    private sendInfo: SendInfoComponentService,
    private lockSessionService: LockSessionService
  ) {
    this.elem = document.documentElement;
    tabsStorageService.updateTabs();
  }

  ngDoCheck(): void {
    if (this.tablist.length === 0) {
      this.tabsStorageService.updateTabs();
    }
  }

  ngOnInit(): void {
    this.fullname = this.userStorageService.getFullName();
    this.updateTabs();

    this.breakpointObserver.observe(['(min-width: 576px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.viewPanel = true;
      } else {
        this.viewPanel = false;
      }
    });
    this.listLanguages();
    this.listTraduction = TranslateHelper.getTranslation('home');
    this.sendInfo.sendObjectAction.subscribe(data => {
      if (data.isExecuted && data.key === "traduction") {
        this.listTraduction = TranslateHelper.getTranslation('home');
      }
    });
  }

  private updateTabs() {
    this.tabsStorageService.getAllTabs().subscribe(tabs => {
      let tabPatient = tabs.find(x => x.tag === "patient-info");
      if (StringUtilsHelper.notNullOrUndefinedOrEmpty(tabPatient)) {
        this.tablist = tabs.filter(x => x !== tabPatient);
      } else {
        this.tablist = tabs;
      }
    });
  }

  closeTab(navTab: NavTabModel) {
    let url = '/home';
    if (navTab.url.includes('/patient/gine-triage') || navTab.url.includes('/patient/general-triage')) {
      if (!navTab.url.includes('/patient/general-triage/result') && !navTab.url.includes('/patient/gine-triage/result')) {
        const confirmExit = confirm("¿Estás seguro de que deseas salir sin guardar cambios?");

        if (confirmExit) {
          this.tabsStorageService.removeItem(navTab.tag);
          TranslateHelper.deleteForm(navTab.url);
          if (this.tablist.length > 0) {
            let tabAux = this.tabsStorageService.getItemByIndex<NavTabModel>(0);
            tabAux.activeTab = true;
            url = tabAux.url;
          }
          this.router.navigate([url]);
        }
      } else {
        this.tabsStorageService.removeItem(navTab.tag);
        TranslateHelper.deleteForm(navTab.url);
        if (this.tablist.length > 0) {
          let tabAux = this.tabsStorageService.getItemByIndex<NavTabModel>(0);
          tabAux.activeTab = true;
          url = tabAux.url;
        }
        this.router.navigate([url]);
      }
    } else {
      this.tabsStorageService.removeItem(navTab.tag);
      TranslateHelper.deleteForm(navTab.url);
      if (this.tablist.length > 0) {
        let tabAux = this.tabsStorageService.getItemByIndex<NavTabModel>(0);
        tabAux.activeTab = true;
        url = tabAux.url;
      }
      this.router.navigate([url]);
    }
  }

  logout() {
    this.userStorageService.logout();
    this.lockSessionService.finalizeLock();
    this.router.navigate(['/']);
  }

  lockSession() {
    this.onLock();
  }

  onViewProfile() {
    const dialogRef = this.dialog.open(ProfileUserDialog, {
      width: 'auto',
      height: 'auto'
    });
  }

  showPanel() {
    if (this.viewPanel) {
      this.viewPanel = false;
    }
    else {
      this.viewPanel = true;
    }
  }

  userProfileExample: string = "headOfService";
  hideBadge() {
    this.hiddenBadge = true;
  }

  isFullScreen: boolean = false;
  openFullscreen() {
    if (!this.isFullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        this.elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
    }
    else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
      this.isFullScreen = false;
    }
  }

  private onLock() {
    this.lockSessionService.expired$.next(true);
    this.lockSessionService.finalizeLock();
    this.lockSessionService.startEndTimer();
    this.userStorageService.setLock(true);
  }

  /**
   * TRANSLATE
   */
  selectLanguage(option: LanguageDto) {
    this.workplaceStorageService.saveLanguageCve(option.languageCve);
    this.translateHelper.updateListTraduction(this.workplaceStorageService.getOrgId());
    this.languageCve = option.languageCve;
    this.sendInfo.sendObject(option.languageCve, "traduction");
  }
  listLanguages() {
    this.languageCatService.getLanguages().subscribe(res => {
      this.languages = res;
      this.languageCve = WorkplaceStorageService.getLanguageCve();
    });
  }
}


